import React from 'react'
import SelectSegments from './../../../components/Select/Books/SelectSegments'

const FilterBooks = ({segments, subjects, authors, publishers, changeFilter}) => {
  const mapSelectOptions = (type) => (type.items.map((item) => ({label: item.name, value: item.id})))
  return (
    <div className='select-filter__wrapper'>
      <div className='select-filter__container'>
          <span className='select-filter__label'>Segmentos: </span>
        {segments.items.length > 0 && (
          <SelectSegments
            options={mapSelectOptions(segments)}
            isLoading={segments.isFetching}
            placeholder='Selecione o(s) segmento(s)'
            changeFilter={changeFilter}
            type='segments'
            multi
            clearable
            minWidth={'150px'}
          />
        )
        }
      </div>
      <div className='select-filter__container'>
          <span className='select-filter__label'>Disciplinas: </span>
        {subjects.items.length > 0 && (
          <SelectSegments
            options={mapSelectOptions(subjects)}
            isLoading={subjects.isFetching}
            placeholder='Selecione a(s) disciplina(s)'
            changeFilter={changeFilter}
            type='subjects'
            multi
            clearable
            minWidth={'220px'}
          />
        )
        }
      </div>
      
      {/* <span className='select-filter__label'>Autores: </span>
      {authors.items.length > 0 && (
        <SelectSegments
          options={mapSelectOptions(authors)}
          isLoading={authors.isFetching}
          placeholder='Selecione o(s) autor(es)'
          changeFilter={changeFilter}
          type='authors'
          multi
          clearable
          minWidth={'150px'}
        />
      )
      } */}
      <div className='select-filter__container'>
          <span className='select-filter__label'>Editoras: </span>
        {publishers.items.length > 0 && (
          <SelectSegments
            options={mapSelectOptions(publishers)}
            isLoading={publishers.isFetching}
            placeholder='Selecione a(s) editora(s)'
            changeFilter={changeFilter}
            type='publishers'
            multi
            clearable
            minWidth={'150px'}
          />
        )
        }
      </div>
      
    </div>
  )
}

export default FilterBooks



// WEBPACK FOOTER //
// ./src/components/Filter/FilterBooks/index.js